import { Preferences } from '@capacitor/preferences';

export async function saveSession(token, user) {
  await Preferences.set({ key: 'token', value: token });
  await Preferences.set({ key: 'user', value: JSON.stringify(user) });
}

// El token dura unos días; si ya ha caducado, mejor no usarlo: todas las
// llamadas darían 401 y el cliente vería la app vacía (sin rutina ni plan).
function tokenCaducado(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(base64));
    return typeof exp === 'number' && exp * 1000 < Date.now();
  } catch {
    return false;
  }
}

export async function getSession() {
  const { value: token } = await Preferences.get({ key: 'token' });
  const { value: user } = await Preferences.get({ key: 'user' });
  if (token && tokenCaducado(token)) {
    await clearSession();
    return { token: null, user: null };
  }
  return { token, user: user ? JSON.parse(user) : null };
}

export async function clearSession() {
  await Preferences.remove({ key: 'token' });
  await Preferences.remove({ key: 'user' });
}
